import React from 'react';
import styles from './index.module.scss';
import { V2EnergyUnitRankingsDetailPostResponse } from '@maxtropy/device-customer-apis-v2';
import { keepPercentOrLine, keepTwoNull } from '@/utils/utils';
export interface ElectricCardProps {
  baseInfo?: V2EnergyUnitRankingsDetailPostResponse['electricRateCardVo'];
  physicalUnitName?: string;
}

// 尖峰平谷总
export enum ElectricCostType {
  SUMMIT = 'summit', // 尖
  PEAK = 'peak', // 峰
  PLAIN = 'plain', // 平
  VALLEY = 'valley', // 谷
}

export const ElectricCostTypeDisplay = {
  [ElectricCostType.SUMMIT]: '尖时段',
  [ElectricCostType.PEAK]: '峰时段',
  [ElectricCostType.PLAIN]: '平时段',
  [ElectricCostType.VALLEY]: '谷时段',
};
export const ElectricCostTypeColor = {
  [ElectricCostType.SUMMIT]: 'var(--mx-diagram17-color)',
  [ElectricCostType.PEAK]: 'var(--mx-diagram18-color)',
  [ElectricCostType.PLAIN]: 'var(--mx-diagram19-color)',
  [ElectricCostType.VALLEY]: 'var(--mx-diagram20-color)',
};

const ElectricCard = ({ baseInfo, physicalUnitName = '--' }: ElectricCardProps) => {
  return (
    <div className={styles.cardWrapper}>
      <div className={styles.card}>
        <div className={styles.unit}>总用量（{physicalUnitName}）</div>
        <div className={styles.num}>{keepTwoNull(baseInfo?.electricity)}</div>
      </div>
      {Object.entries(ElectricCostType).map(([key, value]) => {
        return (
          <div key={key} className={styles.card} style={{ borderColor: ElectricCostTypeColor[value] }}>
            <div className={styles.unit}>
              {ElectricCostTypeDisplay[value]}用量（{physicalUnitName}）
            </div>
            <div className={styles.num}>{keepTwoNull(baseInfo?.[`${value}Electricity`])}</div>
            <div>
              占比：
              <span style={{ color: 'var(--mx-text-base-color)' }}>
                {keepPercentOrLine(baseInfo?.[`${value}Rate`])}%
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ElectricCard;
